<template>
    <div>
        <div class="main-grid-container">
            <div class="profile-label grid-item">
                Forms
            </div>

            <div>
                <ds-dropdown class="dropdown" close-on-menu-click position="bottom-end">
                    <ds-filled-button button-class="primary" data-qa="fill-form-button" @click="getFormsDropDown">
                        Fill form
                        <ds-icon class="chevron" name="chevron-down" />
                    </ds-filled-button>

                    <div slot="menu">
                        <ul class="forms-dropdown-menu-list">
                            <li
                                v-for="form in formsDropDown"
                                :key="form.label"
                                class="dropdown-menu-item"
                                @click="openFormDetailsEdit(form.label)"
                            >
                                {{ form.value }}
                            </li>
                        </ul>
                    </div>
                </ds-dropdown>
            </div>
        </div>

        <template v-if="isContactHasForms">
            <div data-qa="display-fill-forms">
                <ds-table-grid
                    :data="forms"
                    align="center"
                    data-qa="form-table-grid"
                    :click-row="openFormDetails"
                >
                    <ds-table-grid-column
                        class="field-label"
                        label="Form name"
                        width="90"
                    >
                        <template slot-scope="form">
                            <div>
                                <span>
                                    {{ form.formName }}
                                </span>
                            </div>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        class="field-label"
                        label="Date submitted"
                        width="110"
                    >
                        <template slot-scope="form">
                            <span>
                                {{ dateFormatDate(form.submissionDate, 'MMM D, YYYY') }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        class="field-label"
                        label="Submitted by"
                        width="110"
                    >
                        <template slot-scope="form">
                            <span>
                                {{ form.user }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        class="field-label"
                        label="Referring URL"
                        width="220"
                    >
                        <template slot-scope="form">
                            <span>
                                {{ form.referringUrl }}
                            </span>
                        </template>
                    </ds-table-grid-column>
                </ds-table-grid>
            </div>
        </template>

        <div v-if="!isContactHasForms" class="no-forms-section">
            <p class="no-forms-label">
                No Form Submissions on {{ contact.firstName }}
            </p>
        </div>

        <contact-view-form
            ref="viewFormModal"
            :list-form-details="listFormDetails"
            :form-details="formDetails"
            :edit-form-name="formNames"
            :contact="contact"
        />

        <div v-if="isFormsLimitOver" class="view-all-forms-div" @click="showFormsModal">
            <span>Showing {{ getFormsLength() }} of {{ formsCount }}
                <ds-text-button>
                    Show all forms
                </ds-text-button>
            </span>
        </div>

        <contact-forms-modal
            :id="id"
            ref="formsModalPopUp"
            :contact="contact"
        />
    </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import ContactViewForm from './ContactViewForm';
import ContactFormsModal from './ContactFormsModal';

export default {
    components: { ContactFormsModal, ContactViewForm },
    props: {
        id: String,
        contact: Object,
    },
    data() {
        return {
            forms: [],
            listFormDetails: [],
            formType: '',
            formsCount: 0,
            MAX_FORMS_LIMIT: 10,
            formName: '',
            formNames: '',
            formsDropDown: [],
            formDetails: [],
            featureFlagValues: [],
            isFS49980Enabled: false,
        };
    },

    beforeDestroy() {
        this.$root.$off('GET_ALL_FORMS');
    },

    created() {
        this.initTab();
        this.getFeatureFlagValue();
    },

    mounted() {
        this.$root.$on('GET_ALL_FORMS', (flag) => {
            if (flag) {
                this.initTab();
            }
        });
    },

    computed: {
        fullName() {
            return `${this.contact?.firstName} ${this.contact?.lastName}`;
        },

        isFormsLimitOver() {
            return this.formsCount > this.MAX_FORMS_LIMIT;
        },

        isContactHasForms() {
            return this.forms?.length > 0;
        },
    },

    methods: {
        initTab() {
            this.getForms();
            this.getFormsCount();
        },

        async getForms() {
            try {
                const response = await axios.get(`/app/webformSubmission/contactForms/${this.id}/${this.MAX_FORMS_LIMIT}`);

                this.forms = response.data;
            } catch (error) {
                this.$error({ message: 'error while getting forms' });
            }
        },

        dateFormatDate(date, format = 'll') {
            const formattedDate = moment(date).isValid() ? date : new Date(date);

            return moment(formattedDate).format(format);
        },

        async getFormsCount() {
            try {
                const response = await axios.get(`/app/webformSubmission/formsCount/${this.id}`);

                this.formsCount = response.data;
            } catch (error) {
                this.$error({ message: 'error while getting forms count' });
            }
        },

        async getFormsDropDown() {
            try {
                const response = await axios.get('/app/webformSubmission/fillFormDropdown');

                this.formsDropDown = response.data;
                this.formsDropDown = Object.keys(this.formsDropDown).map((key) => {
                    return { label: key, value: this.formsDropDown[key] };
                });
            } catch (error) {
                this.$error({ message: 'error while fetching fill form drop down' });
            }
        },

        async openFormDetails(data) {
            try {
                const response = await axios.get(`/app/webformSubmission/getSubmissionDetails/${data.customFormWebResultId}`);

                this.listFormDetails = response.data;
                this.formType = 'view';
                this.$refs.viewFormModal.showModal(this.formType, 0);
            } catch (error) {
                this.$error({ message: 'error while getting the form submission details' });
            }
        },

        async openFormDetailsEdit(id) {
            try {
                const response = await axios.get(`/app/webformSubmission/forms/${id}/${this.id}`);

                if (this.isFS49980Enabled) {
                    const formData = response.data.fields;

                    formData.forEach((data) => {
                        if (data.label === 'Radio') {
                            data.options.forEach((info) => {
                                if (info.value === 'true') {
                                    data.value = info.name;
                                }
                            });
                        }

                        if (data.label === 'Checkbox') {
                            if (data.value === '1') {
                                data.value = true;
                            } else {
                                data.value = false;
                            }
                        }

                        if (data.name === 'Language') {
                            data.options.forEach((info) => {
                                if (info.value === data.value) {
                                    data.value = info.name;
                                }
                            });
                        }
                    });

                    this.formDetails = formData;
                } else {
                    this.formDetails = response.data.fields;
                }

                this.formType = 'edit';
                this.formNames = response.data.formName;

                this.$refs.viewFormModal.showModal(this.formType, id);
            } catch (error) {
                this.$error({ message: 'error while getting the form fields' });
            }
        },

        getFormsLength() {
            return this.forms?.length > 0 ? this.forms?.length : 0;
        },

        showFormsModal() {
            this.$refs.formsModalPopUp.showAllFormsModal();
        },

        async getFeatureFlagValue() {
            try {
                const response = await axios.get('/app/webformSubmission/getFeatureFlags');

                this.featureFlagValues = response.data;
                this.isFS49980Enabled = this.featureFlagValues.isFS49980Enabled;
            } catch (e) {
                this.$error({ message: 'Unable to get featureFlag value' });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.profile-label {
    font-size: $font-size-xl;
}

.main-grid-container {
    display: flex;
    margin: $spacing-250;
}

.grid-item {
    margin: auto;
    margin-left: 0;
}

.chevron {
    --icon-size: 1rem;
    margin-bottom: - $spacing-050;
}

.view-all-forms-div {
    text-align: center;
    margin-top: 1.75rem;
}

.no-forms-section {
    width: 100%;
    text-align: center;
    border-top: 1px solid $color-gray-lighter;
    margin-top:  $spacing-200;
}

.forms-dropdown-menu-list {
    padding: 0.01rem 0;
}

.no-forms-label {
    color: $color-gray-darker;
    font-size: $font-size-lg;
    font-weight: 300;
    padding-top: $spacing-800;
    padding-bottom: $spacing-600;
}

.field-label {
    font-size: small;
    color: $color-gray-light;
    margin-bottom: auto;
}
</style>
